import { TableRow, TableRowProperties } from 'app/ui'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableRowSummaryProperties<T> = TableRowProperties<T> & {
    className: string
}

export const TableRowSummary = <T extends object>({
    className,
    ...properties
}: Readonly<TableRowSummaryProperties<T>>): JSX.Element => {
    return (
        <TableRow
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
